import { RequestProvider } from '@/shared/providers/request.provider';

class MeetingServiceClass {

  joinMeeting(meetingId: number) {
    return RequestProvider.get(`meeting/${meetingId}/join`); 
  }

  cleanMeetingBoardAnnotations(mainMeetingBoardHash: string) {
    return RequestProvider.remove(`meeting/boards/${mainMeetingBoardHash}`);
  }
}

export const MeetingService = new MeetingServiceClass();
